import { render, staticRenderFns } from "./StatusDiscovery.vue?vue&type=template&id=0babd1e4&"
import script from "./StatusDiscovery.vue?vue&type=script&lang=js&"
export * from "./StatusDiscovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports